import { render } from "./AssignProductsTop.vue?vue&type=template&id=9d9ac6e4&scoped=true"
import script from "./AssignProductsTop.vue?vue&type=script&lang=js"
export * from "./AssignProductsTop.vue?vue&type=script&lang=js"

import "./AssignProductsTop.vue?vue&type=style&index=0&id=9d9ac6e4&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d9ac6e4"]])

export default __exports__